/// <reference path="toolkit/dataclass.js" />
/// <reference path="toolkit/dataclass.js" />
 
import React, { Component, useState }  from 'react';
import { Helper } from '../src/ToolKit/toolkit.js';
import { DataClass, enums } from '../src/ToolKit/DataClass.js'
 
 
import $ from '../node_modules/jquery/dist/jquery';
import { Sidebar, Menu as PMenu, MenuItem, SubMenu } from 'react-pro-sidebar';

import jQuery from '../node_modules/jquery/dist/jquery';
import 'select2';   

import 'select2/dist/css/select2-bootstrap.css';
import {  Link} from "react-router-dom";
import './Parviz';
import '../node_modules/kamadatepicker/dist/kamadatepicker.min.js';
import 'kamadatepicker/dist/kamadatepicker.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { FinYearSelector } from './Page.js';
 
 
window.$ = $;
window.jQuery = jQuery;
const ColumnType={
    DisplayValue: 1, InputText: 2, InputCheck: 3, DisplayEnum: 4, DisplayDigidGrouped: 5, InputNumberDigited: 6, InputSelect2Static: 7,InputFloat:15, InputSelect2Ajax: 8, InputDate: 9, FunctionValue: 10, FunctionValueDigied:11,InputLongText:12,Image:13
    , InputImage: 14, CustomElement: 16 ,Serach :17
}




console.log(DataClass.User);
class DropDownBox extends React.Component {
    /**
    *
    * @param {{ entity:string,customArgs:Function ,multi:boolean,tableMode:boolean,onChange:Function,defaultValueCellCaption:string,includeAll:boolean,columnName:string ,mustFill:string ,caption:string  ,size:string}} props
    */
    constructor(props) {

        super(props);

        this.props = props;
        this.entity = props.entity;
        this.includeAll = props.includeAll;
        this.onChange = props.onChange;
        this.multiple = props.multi == true;
        this.extraOptions = props.extraOptions;
        this.customArgs = props.customArgs;

    }


    componentDidMount() {
        let cmd = this;
        const setConfig = function () {

            console.log(cmd.props.columnName);
            $('#' + 'txt' + cmd.props.columnName + (cmd.props.tableMode ? cmd.props.rownum : '')).select2({
                width: 'resolve',
                ajax: {
                    url: '/Home/QuickSerach',
                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
                    data: function (params) {
                        var query = {
                            search: params.term,
                            type: 'public',
                            customArgs: (cmd.customArgs == undefined ? '' : cmd.customArgs()),
                            entity: cmd.entity, includeAll: cmd.includeAll, extraOptions: cmd.extraOptions == undefined ? '' : cmd.extraOptions
                        }
                        for (let i = 0; i < query.customArgs.length; i++) {
                            query['args[' + i + ']'] = query.customArgs[i];
                        }
                        // Query parameters will be ?search=[term]&type=public
                        return query;
                    }
                }
            });
            $('#' + 'txt' + cmd.props.columnName + (cmd.props.tableMode ? cmd.props.rownum : '')).on('change', cmd.props.onChange);
        }


        if (document.readyState == "loading") {
            $(document).ready(function () {
                setConfig();
            });
        }
        else {
            setConfig();
        }
    }



    render() {

        if (DontMustBeRender(this.props.ForApp)) {
            return null;
        }

        let customProp = CustomPropForInput(this.props);
        if (this.multiple) {
            customProp.multiple = "multiple";
        }

        if (this.props.tableMode == true) {
            return <select type="text" /* style={{ width: this.props.width }}*/ includeAll={this.props.includeAll} datatype="value" {...customProp} className="form-control" id={'txt' + this.props.columnName + this.props.rownum} >
                {this.props.defaultValueCellCaption != undefined && <option value={this.props.value}>{this.props.defaultValueCellCaption}</option>}
            </select>
                ;



        }
        else {
            return <FormDiv size={this.props.size}> <label className="form-label">{this.props.caption} {this.props.mustFill == 'Yes' && <ReqFilled />} </label>
                <select extraOptions={this.extraOptions} type="text" model={this.props.columnName} includeAll={this.props.includeAll} datatype="value" {...customProp} className="form-control" id={'txt' + this.props.columnName} />
            </FormDiv>;

        }



    }
}

window.checkEnter = function (evt) {
    const form = evt.target;
   
    
      
    if (evt.key === `Enter`) {
        var z = document.getElementsByClassName('trumbowyg-editor');
        if (document.getElementsByTagName("textarea").length > 0) {
            return true;
        }
        if (z.length == 0) {
            evt.preventDefault();
            return;
        }
            
            }
            return true;
        
    
}


const FixedMessage = {
    NoProblem: 'با موفقیت انجام گردید', AreYouSure: 'آیا مطممن هستید؟', DeleteRow:'حذف ردیف',ErrorRaise:'خطا در انجام عملیات'
    , Result: 'نتیجه',NewRow:'رکورد جدید' , FliterMessage: 'جهت فیلترینگ دراین  قسمت عبارت مورد نظر را تایپ کنید', Submit: 'تایید', Back: 'بازگشت', NeedLogin: 'نیاز به ورود مجدد می باشد', NotPermited: 'شما به این قسمت دسترسی ندارید لطفا با مدیریت سامانه این مسله را در میان بگذرید'
,LoadLoginInfo: 'در حال دریافت اطلاعات ورود ...',Err404:'صفحه مورد نظر یافت نشد یا پیاده سازی نشده است',CantConnetServer:'عدم ارتباط با سرور ... لطفا بعدا امتحان کنید',Login:'ورود',PleaseWait:'لطفا منتظر باشید...'
}
const SpecValues = {
    RowNum:'#RowNum'
}
const CustomHelper = {
 isDate:1,isDigitngGroupedNumber:2,File:3,LongText:4,cardMode:5,timeMode:6,Html:7,Image:8
};
Object.freeze(ColumnType);
Object.freeze(FixedMessage);
  function Home() {
    return <h2>Home</h2>;
  }
  
  function About() {
    return <h2>About</h2>;
  }
  
  function Users() {
    return <h2>Users</h2>;
  }
  
  
  
  var Mx;
  
   
   class Menu extends React.Component
  {
       
      constructor(props){
    
          super(props) ;
          this.state = {
              isLoaded: false,Items:[],LoginInfo:null
           }; 
           this.props=props;
          Mx = this;
          window.reloadStatus = this.reloadMenu.bind(this);
       }



       reloadMenu() {
           let Component = this;
           let Helpx = new Helper();
           Helpx.Ajax('Home', 'GetLoginInfo', {}, function (datai) {
               window.LoginInfo = datai;
               let temp = Component.state;
               temp.LoginInfo = datai;
               Component.setState(Component.state);
               window.menuMen = Component.state;
           });

       }

       componentDidMount() {
         
           //alert(this.props.id);
           //alert(window['d_' + this.props.id]);
           //if (window['d_' + this.props.id] !== undefined) {
           //    $('#' + this.props.id).html(window['d_' + this.props.id]);
           //}

        let Component =this;
            let Helpx=new Helper();
          if (this.state.isLoaded == false) {
              Helpx.Ajax('Home','GetMenu',{ },
               function(data){
                 Component.setState(
                     { isLoaded: true, Items: data, LoginInfo:null }
                   );

                   Helpx.Ajax('Home', 'GetLoginInfo', {}, function (datai) {
                       window.LoginInfo = datai;
                       let temp = Component.state;
                       temp.LoginInfo = datai;
                       Component.setState(Component.state);
                       window.menuMen = Component.state;
                   });

               },function(err) {}
              );
          }
        
      }
       putItem(v) {
           
               //if (v.link == '#') {
               //    return <SubMenu label={v.title} sub icon={<Icon Icon={v.icon} ></Icon>}>

               //        {v.subItems.map((v2) => {
               //            return <MenuItem component={<Link to={"/Admin/" + v2.link}></Link>} ><Icon Icon={v2.icon} ></Icon> {v2.title}
               //            { v2.subItems.map((v3) => { return this.putItem(v3) }) }
               //            </MenuItem>

               //        })}
               //    </SubMenu>
               //}


           //return <MenuItem component={<Link to={"/Admin/" + v.link}></Link>} ><Icon Icon={v.icon} ></Icon> {v.title}


           //</MenuItem>
           if (v.subItems.length > 0) {
               return <SubMenu label={v.title} sub icon={<Icon Icon={v.icon} ></Icon>}>
                   {v.subItems.map((v2) => {
                       return this.putItem(v2);

                   })}
               </SubMenu>
           }
           else {
               return <MenuItem component={<Link to={"/Admin/" + v.link}></Link>} ><Icon Icon={v.icon} ></Icon> <span linkpoint={v.link }></span> {v.title}</MenuItem>;
           }

       }
  
       render() {

           if (window.LoginInfo == null) {
               return <span></span>
           }
           let hlp = new Helper();
           let sexName = hlp.GetCaptionFromEnum(enums.Sex, window.LoginInfo.sex);
          /*
           {window.LoginInfo.planTitle !== '-'}
               {
                   <center>
                       <h5>طرحی فعلی:<br /></h5>
                       {window.LoginInfo.planTitle} <br />
                       <h5>بازی در اختیار:<br /></h5>
                       {window.LoginInfo.gameUsage} <br />
                   </center>
               }
          */
           return <PMenu >
              

               {this.state.Items.map((v) => {return this.putItem(v) })}

               <SubMenu label={sexName + ' ' + window.LoginInfo.fullName} icon={<img src={window.LoginInfo.imgSrc} alt="" width="32" class="rounded-circle me-2" />}>
                   <MenuItem component={<Link to="PassChange"></Link>}><Icon Icon="Password"></Icon>تغییر گذرواژه</MenuItem>
                   <MenuItem component={<Link to="UserProfile"></Link>}><Icon Icon="User"></Icon>تغییر عکس پروفایل</MenuItem>
                   <MenuItem >
                       <a onClick={this.LogOut} class="dropdown-item" href="#"> <Icon Icon="LogOut"></Icon>خروج از حساب کاربری </a>
                   </MenuItem>
                   
               </SubMenu>
              
           </PMenu>


          
 
           return <div class="d-flex flex-column flex-shrink-0 p-3  " id={this.props.id } style={{ width:'100%' }}>
               
               <hr />
               <ul class="nav nav-pills flex-column mb-auto">
                    
               </ul>
               {this.state.isLoaded == true &&
                   <ul className="list-unstyled ps-0">
                         <Item title="خانه" link="/Admin" />   {this.state.Items.map(function (ele, index) {
                   return <Item key={index} link={ele.link} Icon={ele.icon} title={ele.title}  >{ele.subItems.map(
                       function (ele2, index) {
                           return <SubItem key={index} Icon={ele2.icon} link={ele2.link} title={ele2.title }></SubItem>;
                       }

                             )}</Item>

                             
               })}

                   </ul>
               }

               



               <hr />
               <div class="dropdown">
                   <a href="#" class="d-flex align-items-center  text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
                       <img src={window.LoginInfo.imgSrc} alt="" width="32"   class="rounded-circle me-2" />
                       <strong style={{color:'black'} }>{sexName + ' ' + window.LoginInfo.fullName}</strong>
                   </a>
                   <ul class="dropdown-menu dropdown-menu-light  shadow" aria-labelledby="dropdownUser1">
                    
                       <li><Link class="dropdown-item" to="PassChange">
                            <Icon Icon="Password"></Icon>
                           تغییر گدرواژه </Link></li>
                       <li><Link class="dropdown-item" to="UserProfile">   <Icon Icon="User"></Icon>تغییر تصویر پروفایل </Link></li>
                       <li><a onClick={this.LogOut} class="dropdown-item" href="#"> <Icon Icon="LogOut"></Icon>خروج از حساب کاربری </a>
                       </li>
                   </ul>
               </div>
           </div>;






           <nav className="navbar navbar-expand-lg navbar-light bg-light">
       <div className="container-fluid">
       <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
           <span className="navbar-toggler-icon"></span>
       </button>

  
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
          
               {this.state.isLoaded == false &&
               <ul className="navbar-nav mr-auto">    <Item link="" title="در حال دریافت گزینه های منو"> </Item>  </ul>
               }
               {this.state.isLoaded == true &&
                   <ul className="navbar-nav mr-auto">
                         <Item title="خانه" link="/" />   {this.state.Items.map(function (ele, index) {
                   return <Item key={index} link={ele.link} Icon={ele.icon} title={ele.title}  >{ele.subItems.map(
                       function (ele2, index) {
                           return <SubItem key={index} Icon={ele2.icon} link={ele2.link} title={ele2.title }></SubItem>;
                       }

                   )}</Item>
               })} </ul>
                


               }
               
            

           </div>
           <form class="d-flex" role="search">
               <ul className="navbar-nav mr-auto">
                   <Item img={window.LoginInfo.imgSrc   } title={ sexName + ' ' +     window.LoginInfo.fullName + ' ' + 'خوش آمدید'} link='#' >
                       <SubItem title='تغییر گذرواژه' Icon="Password" link="PassChange" />
                       <SubItem title='تغییر تصویر پروفایل' Icon="User" link="UserProfile" />

                       <FunctionLink title='خروج از سامانه ' Icon="Logout" onClick={this.LogOut} />

                   </Item>

               </ul>
                   </form>     
    </div>
  </nav>;
   
       }



       LogOut() {
           window.LogOut();
       }
  } 
  function HomeButton(props){
  return <a   className="navbar-brand" href="#">خانه</a>;
  
}
 


function FunctionLink(prop) {
    return <a className="dropdown-item" onClick={prop.onClick}>{prop.title} {prop.Icon != undefined && <Icon Icon={prop.Icon} />}</a>


} 
function Icon(prop) {
    if (prop.Icon.indexOf('bi') == 0) {
        return <i className={prop.Icon}></i>;
    }
    else {
        return <img src={'\\Icons\\' + prop.Icon + '.png'} style={{ height:'24px', width: '24px', float: (prop.subItem == undefined ? 'right' : 'null') }} ></img>;
    }
}

  function SubItem(prop)
  {

      return <li> <Link style={{ cursor: 'pointer !important', width: '100%' }} className="link-dark rounded" onClick={() => { window.d_fullMenu = $('#fullMenu').html(); window.d_sideMenu = $('#sideMenu').html(); }} to={"/Admin/" + prop.link}><span style={{ display: 'inline-block', width: '30px' }} ></span>{prop.Icon != undefined && <Icon subItem="yes" Icon={prop.Icon} />}{prop.title} </Link></li>
}
function AddButton(prop = { entity :''}) {

    return <Link to={'/Admin/' + prop.entity + '/Add'} > <SimpleButton Icon='New' title='جدید'> </SimpleButton></Link>

}
function DontMustBeRender(ForApp) {
    let dontRender = false;
  
    if (ForApp != undefined) {

        if (ForApp == "Game" && window.config.GameMode == "False") {
            dontRender = true;
        }
        if (ForApp == "MultiPrice" && window.config.MultiPrice == "False") {
            dontRender = true;
        }
        if (ForApp == "Granty" && window.config.GrantyPrice == "False") {
            dontRender = true;
        }
    }
    return dontRender;
}


function SimpleButton(prop) {
/**
*

* @param {{ title:String ,onClick:Function ,ForApp:string}} props
    */
    
    if (DontMustBeRender(prop.ForApp)) {
        return null;
    }
    
   


    return <button type="button" style={prop.style} width="250px" className="btn btn-light" id={prop.id != undefined ? prop.id:null} onClick={prop.onClick}> {prop.Icon != undefined && <Icon Icon={prop.Icon} />}  {prop.title}</button>;
   // return <Button variant="outlined" onClick={prop.onClick}>{prop.title}</Button>;

}
function LoadingBar() {
    return <div className="spinner-grow text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
        
</div>
}
function FileProgess(porps) {

    return <div className='Progr' style={{display:'none'} }> <div class="progress">
        <div class="progress-bar" role="progressbar" style={{ width:'25%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
    </div>
        </div>
        ;
}
  function Item(prop)
  {

      let rnd = Math.random() * 100000;

      if ((prop.children != undefined) && (prop.children.length>0))
     {
          return <li className="mb-1">

              <button style={{ cursor: 'pointer !important',width:'100%' }} class=" btn-toggle align-items-center rounded collapsed" data-bs-toggle="collapse" data-bs-target={'#item' + rnd} aria-expanded="false">
                  {prop.Icon != undefined && <Icon Icon={prop.Icon} isMenu={true} />} {prop.title} 

              </button>

              <div class="collapse" id={'item' + rnd  }>
                  <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                      {prop.children}
                  </ul>
              </div>
          </li>;

        
  
     }
     else
     {
          return <li className="nav-item">
              <Link className="nav-link" to={prop.link}>{prop.title} {prop.Icon != undefined && <Icon Icon={prop.Icon} />}</Link>
     </li> ;
  
     }
  
  }
  
  
  
  function SerachBar()
  {
  return   <form className="d-flex" role="search">
  <input className="form-control me-2" type="search" placeholder="جست و جو " aria-label="Search" />
  <button className="btn btn-outline-success" type="submit">بیاب</button>
   
  
  </form>;
  
      
}




class Action extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;

    }
    render() {
        return <div />;

    }

}


class DayTimeSelector extends React.Component
{
/**
*
* @param {{datasource:Array,dayNames:Array }} props
*/
    constructor(props) {
        super(props);
        
        this.dayNames = ['شنبه', 'یک شنبه', 'دو شنبه', 'سه شنبه', 'چهار شنبه', 'پنچ شنبه'];
        this.Times = ['8 الی 10', '10 الی 12', '14 الی 16', '16 الی 18'];
        this.state = { datasource: props.datasource };
        window.DaySelect = props.datasource;
    }


    render() {
        return <center>
            <form className='row g-3'  ><FormDiv size='100%'><div><button type='button' className='btn btn-outline-success' style={{ width: '100%', height: '50px' }} onClick={() => {
                let q = this.state.datasource;
                for (let i = 0; i < 6; i++) {
                    for (let i2 = 0; i2 < 4; i2++) {
                        q[i][i2] = 0;
                    }
                }

                this.setState({ datasource: q });
                window.DaySelect = q;
            }} > پاکسازی</button></div></FormDiv>
                </form><hr />
            {
                this.dayNames.map((v, i, m) => {
                    return <form className='row g-3'  ><FormDiv size='18%'><div><button type='button' className='btn btn-outline-success' style={{ width: '100%', height: '50px' }} onClick={() => {
                        let q = this.state.datasource;
                        for (let i2 = 0; i2 < 4; i2++) {
                            q[i][i2] = q[i][i2] == 1 ? 0 : 1;
                        }
                       
                        this.setState({ datasource: q });
                        window.DaySelect = q;
                    }} > {v}</button></div></FormDiv>
                        {this.Times.map((v2, i2, a) => {
                            return <FormDiv size='18%'><button type='button' style={{ width: '100%' , height:'50px'} } className={(this.state.datasource[i][i2] == 1 ? 'btn btn-success' : 'btn btn-outline-success')} onClick={(x) => {
                                 

                                let q = this.state.datasource;
                                q[i][i2] = q[i][i2] == 1 ? 0 : 1;
                                this.setState({ datasource:q});
                                window.DaySelect = q;
                            }} > {v2}</button></FormDiv>

                        })}
                    </form>
                })
            }
        </center>;
    }
}


class FuncLink extends React.Component {
    constructor(props) {

        super(props);
        this.targetFun = props.targetFun;
        this.porps = props;
        this.DataRow = props.DataRow;
        this.Do = this.Do.bind(this);
        console.log('FuncLink = ' + props.DataRow);
    }
    Do() {

        this.targetFun(this.DataRow);
    }
    render() {

        return (<a className="dropdown-item" onClick={this.Do}    >
           
            {this.props.showValue} {this.props.Icon != undefined && <Icon Icon={this.props.Icon} />} </a>);

    }

}

const RowState = {
    NoChanged: 0, Changed: 1,Inserted:2,Deleted:3
}

class ProTable extends React.Component {
/**
*
* @param {{ rowNumbering:Boolean,povitColumns:Array,Records:Array ,datasourcename:String , HideRecordCount:Boolean,HideFiltering:boolean,Insertable:boolean ,Deleteable:boolean,afterChange:Function,rowFormating:Function}} props
*/
    constructor(props) {
        super(props);
        this.props = props;
        this.rndId = "tb_" + Math.floor((Math.random() * 1000)).toString();
        this.state = {
            Record: props.Records, fliter: '', enumFilter: {} };
        this.SetFilter = this.SetFilter.bind(this);
        this.change = this.change.bind(this);
        this.addchange = this.addchange.bind(this);
        this.Insertable = this.props.Insertable;
        this.Insert = this.Insert.bind(this);
        this.Deleteable = this.props.Deleteable;
        this.openFileMgt = this.openFileMgt.bind(this);
        this.DeleteRow = this.DeleteRow.bind(this);

        window[this.props.datasourcename + '_Delete'] = this.DeleteRow;
        this.DeleteConfirm = this.DeleteConfirm.bind(this);
        this.afterChange = props.afterChange;
        this.rowFormating = props.rowFormating;
        this.rowNumbering = props.rowNumbering;
        window.currentTable = this;
        if (this.afterChange != undefined) {
            this.afterChange = this.afterChange.bind(this);
        }
        this.HideFiltering = props.HideFiltering;
        this.DataSourceName = props.datasourcename;
        if (this.state != undefined) {
            window[this.DataSourceName] = this.state.Record;
        }
        this.DeleteRow = this.DeleteRow.bind(this);

    }
    DeleteRow(rec) {
        window.RecordToDelete = rec;
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, FixedMessage.Result, function () {
            cmd.DeleteConfirm(window.RecordToDelete);
        });
    }

    validate(id) {
        let h = new Helper();

        if (this.props.customHelper == CustomHelper.isDate) {
            let va = window.$('#' + id).val();
            if (va.length == 8) {
                let val = va.substring(0, 4) + '/' + va.substring(4, 6) + '/' + va.substring(6, 8);
                window.$('#' + id).val(val);
            }

        }

       
    }



    DeleteConfirm(rec) {
      let  i = window[this.DataSourceName].indexOf(rec);
        let state = window[this.DataSourceName][i].rowState;
        if ((state == RowState.NoChanged) || (state == RowState.Changed) || (state == undefined) ){
            window[this.DataSourceName][i].rowState = RowState.Deleted;
        }
        else {
            window[this.DataSourceName].splice(i, 1);
        }
        this.setState({ Record: window[this.DataSourceName], fliter: this.state.fliter }); 
    }

    change(value, index, ColName, customHelper, rerender) {
      
        if (customHelper == CustomHelper.isDigitngGroupedNumber) {
            value = value.replace(/,/g, '');
        }

        window[this.DataSourceName][index][ColName] = value;

        if (window[this.DataSourceName][index].rowState == undefined) {
            window[this.DataSourceName][index].rowState = RowState.Changed;
        }
        if (this.afterChange != undefined) {
            this.afterChange(window[this.DataSourceName], value, index, ColName);
        }
       

        this.setState({ Record: window[this.DataSourceName], enumFilter: this.state.enumFilter, fliter: this.state.fliter });

         
    }
    addchange(value, index, ColName, customHelper, rerender) {
     

        window[this.DataSourceName][index][ColName] = parseFloat(window[this.DataSourceName][index][ColName]) + value;

        if (window[this.DataSourceName][index].rowState == undefined) {
            window[this.DataSourceName][index].rowState = RowState.Changed;
        }
        if (this.afterChange != undefined) {
            this.afterChange(window[this.DataSourceName], value, index, ColName);
        }


        this.setState({ Record: window[this.DataSourceName], enumFilter: this.state.enumFilter, fliter: this.state.fliter });


    }


    selectAll(val, colname) {
        $('input[columnname="' + colname + '"]').each((index, ele) => {
            ele.checked = val;
            ele.value = val;
            this.change(val, $(ele).attr('index'), colname);
        }
        );

    }

    renderHeader(key, caption, Col) {
        return <th key={key} scope="col" style={{ width: Col.width }} >{caption}
            {Col.type == ColumnType.InputCheck && <input type='checkbox' onClick={(e) => {
                this.selectAll(e.target.checked, Col.columnName);
            }} />}
            {Col.type == ColumnType.DisplayEnum &&
                <select className="controll" onChange={(e) => {
                    let s = this.state;
                     
                    s.enumFilter[Col.columnName] = e.target.value;
                    s.Record = s.Record;
                 
                    this.setState({ Record: s.Record, randomKey: Math.random(), enumFilter: s.enumFilter, fliter: s.fliter });
                }}>
                    <option value="">همه موارد</option>
                    {Col.source.map((x) => {return <option value={x.value}>{x.caption}</option> })}
                </select>    
            }



        </th>;
    }

    SetFilter(e) {
        this.setState({ Record: this.props.Records, fliter: e.target.value });
         
    }
    Insert() {
        let Record = new Object();
        for (let i = 0; i < this.props.children.length; i++) {
            if (this.props.children[i].type == NewRecordValue) {
                let value = this.props.children[i].props.newValue;
                if (value == SpecValues.RowNum) {
                    value = this.state.Record.length + 1;
                }
                Record[this.props.children[i].props.columnName] = value ;

            }
           
        }
        Record.rowState = RowState.Inserted;
        window[this.DataSourceName].push(Record);
        this.setState({ Record: window[this.DataSourceName], fliter: this.state.fliter }); 

    }
    InitPickerDate(target) {
        
        if (target.getAttribute('DateMode') == undefined) {
            window.kamaDatepicker(target.id, {
                markToday: true,
                onSelect: function (date) {
                    alert(date);
                    // صدا زدن رویداد change به صورت دستی
                    $(target).trigger('change');
                }


            });
            target.setAttribute('DateMode', 'Yes');
        }

    }
    openLink(e) {
        let h = new Helper();
        h.viewFile(e.target.getAttribute('link'), e.target.getAttribute('filename'));
    }
    openFileMgt(callOfBack) {
        var w = window.open('/Home/FileMgt');
        setTimeout(() => {
            w.fileMgtCallback = (x) => {
                let h = new Helper();

                if (x.length == 0) {
                    h.Alert("هیچ فایلی انتخاب نشده است");
                }
                if ((x[0].exe.toLowerCase() == '.jpg') || (x[0].exe.toLowerCase() == '.png')) {
                    callOfBack("/content/" + x[0].fullName.substring(0, x[0].fullName.length - 1));
                }
                else {
                    h.Error('لطفا یک عکس انتخاب کنید');
                }
            }
            w.refList();
        }, 3000);
    }


    render() {
        if (this.props.Records == undefined) {
            return <span></span>;
        }
      


        console.log("render");
        let helpcnt = new Helper();
        let needNormaliazeSelect2 = false;
        const cols = [];
       
        let colData = [];
        let hasAction = false;
        if (this.rowNumbering == true) {
            cols.push(<td>ردیف</td>);

        }





        if (this.props.children.length != undefined) {
            for (let i = 0; i < this.props.children.length; i++) {
                if (this.props.children[i].type == Column) {
                    colData[i] = new Object();
                    let keyC = Object.keys( this.props.children[i].props);
                    for (let l2 = 0; l2 < keyC.length; l2++) {
                        colData[i][keyC[l2]] = this.props.children[i].props[keyC[l2]];
                    }
                    

                    if (colData[i].metaForDisplay != undefined) {
                        let meta = this.props.children[i].props.metaForDisplay;
                        colData[i].columnName = helpcnt.jsonNameFix(meta.name);
                        colData[i].type = ColumnType.DisplayValue;
                        colData[i].caption = meta.DisplayName;
                        if (meta.MoneyDigited != undefined) {

                            colData[i].type = ColumnType.DisplayDigidGrouped
                        }


                        if (meta.type.indexOf('System.') == -1) {

                            colData[i].source = enums[meta.type.replace('Reach.', '')];
                            colData[i].type = ColumnType.DisplayEnum;
                        }
                       

                    }
                    if (this.props.children[i].props.metaForInput != undefined) {
                        let meta = this.props.children[i].props.metaForInput;
                        colData[i].columnName = helpcnt.jsonNameFix(meta.name);
                        colData[i].type = ColumnType.InputText;
                        colData[i].caption = meta.DisplayName;
                        if (meta.mustFill != undefined) {
                            colData[i].mustFill = 'Yes';
                        }
                        if (meta.LongText != undefined) {
                            colData[i].type = ColumnType.InputLongText;
                        }
                        
                        if (meta.MoneyDigited != undefined) {

                            colData[i].type = ColumnType.InputNumberDigited;
                            colData[i].customHelper = CustomHelper.isDigitngGroupedNumber;
                        }
                        if (meta.type.indexOf('System.') == -1) {

                            colData[i].source = enums[meta.type.replace('Reach.', '')];
                            colData[i].type = ColumnType.InputSelect2Static;
                        }
                        if (meta.ForeignKey != undefined) {
                             
                            colData[i].type = ColumnType.InputSelect2Ajax;
                            colData[i].entity = meta.ForeignKey;
                            colData[i].includeAll = this.props.children[i].props.includeAll;
                            colData[i].titleColumnName = this.props.children[i].props.titleColumnName;

                        }
                        if (meta.type.indexOf('System.DateTime')!=-1) {

                            colData[i].type = ColumnType.InputDate;
                             

                        }


                    }



                    cols.push(this.renderHeader(i, colData[i].caption, colData[i]));
                }
             



                if (this.props.children[i].type == Action) {
                    hasAction = true;

                }
                if (this.props.children[i].length != undefined) {
                    hasAction = true;
                    for (let index = 0; index < this.props.children[i].length; index++) {
                        this.props.children.push(this.props.children[i][index]);
                    }
                }
            }
        }
        if (this.props.povitColumns != undefined) {
            for (let povitIndexColumn = 0; povitIndexColumn < this.props.povitColumns.length; povitIndexColumn++) {
                cols.push(<th scope="col">{this.props.povitColumns[povitIndexColumn]}</th>);
            }

        }

        if (this.Deleteable == true) {
            hasAction = true;
        }
        
        if (hasAction) {
            cols.push(<th>عملیات</th> );
        }
        let counter = 0;
        const rows = [];
        let deteted =0;
        for (let j = 0; j < this.props.Records.length; j++) {
            if (this.state != null)
                if (this.state.fliter != '') {
                    if (helpcnt.FliterArray(this.props.Records[j], this.state.fliter) == false) {
                        console.log(this.props.Records[j]);
                        continue;
                    }
                }
            if (this.props.Records[j].rowState == RowState.Deleted) {
                deteted += 1;
                continue;
            }
            var filterEnumsKeys = Object.keys(this.state.enumFilter);
            let enumFilterApply = false;
            for (let i = 0; i < filterEnumsKeys.length; i++) {
                let ke = filterEnumsKeys[i]
                
                if (this.state.enumFilter[ke] != "") {
                    
                    if (this.props.Records[j][ke] != this.state.enumFilter[ke]) {
                        enumFilterApply = true;
                        continue;
                        
                    }
                }
                
            }
            if (enumFilterApply == true) {
                continue;
            }

            counter += 1;
            const vals = [];

            if (this.rowNumbering == true) {
                vals.push(<td >{counter}</td>);
            }

            
            for (let i = 0; i < this.props.children.length; i++) {

                if (this.props.children[i].type == Column) {

                    let value = this.props.Records[j][colData[i].columnName];
                    let customProp = CustomPropForInput(colData[i]);
                    if (colData[i].type == ColumnType.DisplayValue) {
                        vals.push(<td data-label={colData[i].caption}>{value}</td>);

                    }
                    if (colData[i].type == ColumnType.Image) {
                        vals.push(<td data-label={colData[i].caption}><img width="100px" alt="" src={colData[i].url + value + colData[i].ext} ></img></td>);

                    }
                    if (colData[i].type == ColumnType.DisplayDigidGrouped) {
                        vals.push(<td data-label={colData[i].caption}> {window.addCommas(value)}</td>);

                    }
                    if (colData[i].type == ColumnType.FunctionValue) {
                        let cr = this.props.Records[j];
                        let v = colData[i].customFunction(cr);

                        vals.push(<td data-label={colData[i].caption}> {v}</td>);

                    }
                    if (colData[i].type == ColumnType.FunctionValueDigied) {
                        let cr = this.props.Records[j];
                        let v = colData[i].customFunction(cr);

                        vals.push(<td data-label={colData[i].caption}> {window.addCommas(v)}</td>);

                    }
                    if (colData[i].mustFill != undefined) {
                        customProp.mustFill = "yes";
                    }

                    if (colData[i].type == ColumnType.InputText) {
                        vals.push(<td data-label={colData[i].caption}>  <input type={'text'} rownum={counter} className='form-control' {...customProp} value={value} onChange={(e) => { this.change(e.target.value, j, colData[i].columnName) }} /> </td>);
                    }
                    if (colData[i].type == ColumnType.InputImage) {
                        vals.push(<td data-label={colData[i].caption}>  <img width="100px" alt="تصویری مشخص نشده" src={value} ></img><br />
                            <SimpleButton title="انتخاب فایل" onClick={() => {
                                this.openFileMgt((url) => {
                                    this.change(url, j, colData[i].columnName);
                                })
                            }} ></SimpleButton>
                        </td>);
                    }
                    if (colData[i].type == ColumnType.CustomElement) {
                        vals.push(<td data-label={colData[i].caption}>{colData[i].customElement(this.props.Records[j])}</td>);
                    }
                    if (colData[i].type == ColumnType.Serach) {
                        vals.push(<td data-label={colData[i].caption}>
                            <SimpleButton title="..."
                                onClick={() => {
                                  

                                   
                                    window.targetRowIndex = j;
                                    window.newValueColumn = colData[i].targetColumn;
                                    window.datasourcename = this.DataSourceName;
                                    window.destValue = colData[i].destValue;
                                    window.destTitle = colData[i].destTitle;
                                    window.changeFnc = this.afterChange;
                                    window.colNameValue = colData[i].colNameValue;
                                    window.currentTable = this;
                                    $('#' + colData[i].modalId).modal('show');
                                    colData[i].initFunc();
                                    window.selectFun = (v) => {
                                        let cmd = new Helper();
                                        cmd.Select2AjaxSelectOption(v[window.destValue], document.getElementById('txt' + window.newValueColumn + (window.targetRowIndex + 1).toString()), cmd);

                                       // window[window.datasourcename][window.targetRowIndex][window.newValueColumn] = v[window.destValue];
                                        
                                       // window[window.datasourcename][window.targetRowIndex][window.colNameValue] = v[window.destTitle];
                                       //// 
                                       // if (window.changeFnc != null) {
                                          
                                       //     window.changeFnc(window[window.datasourcename], v[window.destValue], window.targetRowIndex, window.newValueColumn);
                                           
                                       // }
                                       // alert(v[window.destValue]);
                                       // alert(v[window.destTitle]);
                                       // $('#txt' + window.newValueColumn + (window.targetRowIndex + 1).toString()).val(v[window.destValue]).trigger('change');
                                        $('#' + colData[i].modalId).modal('hide');
                                     };
                                }}
                            ></SimpleButton>
                        </td>);
                    }



                    if (colData[i].type == ColumnType.InputDate) {
                        vals.push(<td data-label={colData[i].caption}>  <input type={'text'} rownum={counter} className='form-control' id={'txt' + colData[i].columnName + counter} {...customProp} value={value} customHelper={CustomHelper.isDate} onClick={(e) => { console.log(e.target.id); }} onChange={(e) => { this.change(e.target.value, j, colData[i].columnName, null, colData[i].rerender); }} placeholder="yyyy/mm/dd" /> </td>);
                    }
                    if (colData[i].type == ColumnType.InputLongText) {
                        vals.push(<td data-label={colData[i].caption}>  <textarea type={'text'} rownum={counter} className='form-control' id={'txt' + colData[i].columnName + counter} {...customProp} onClick={(e) => { }} onChange={(e) => { this.change(e.target.value, j, colData[i].columnName,null, colData[i].rerender) }} >{value}</textarea></td>);
                    }
                    if (colData[i].type == ColumnType.InputSelect2Static) {
                        needNormaliazeSelect2 = true;
                        vals.push(<td data-label={colData[i].caption}>  <SelectBasic tableMode={true} width={colData[i].width} rownum={counter} className='form-control' {...customProp} value={value} onChange={(e) => { console.log('printer'); this.change(e.target.value, j, colData[i].columnName, null, colData[i].rerender) }} /> </td>);
                    }
                    if (colData[i].type == ColumnType.InputNumberDigited) {
                        needNormaliazeSelect2 = true;
                        vals.push(<td data-label={colData[i].caption}>  <input type={'text'} rownum={counter} className='form-control' {...customProp} value={window.addCommas(value)} onChange={(e) => { this.change(e.target.value, j, colData[i].columnName, CustomHelper.isDigitngGroupedNumber,  colData[i].rerender) }} /> </td>);
                    }
                    if (colData[i].type == ColumnType.InputFloat) {
                      
                        vals.push(<td data-label={colData[i].caption}>  <input type={'text'} rownum={counter} className='form-control' {...customProp} value={value} onChange={(e) => { this.change(e.target.value, j, colData[i].columnName, CustomHelper.isDigitngGroupedNumber, colData[i].rerender) }} /> </td>);
                    }



                    if (colData[i].type == ColumnType.InputCheck) {
                        vals.push(<td data-label={colData[i].caption}>  <input type={'checkbox'} rownum={counter} index={j}  {...customProp} checked={value} onChange={(e) => { this.change(e.target.checked, j, colData[i].columnName, null, colData[i].rerender) }} /> </td>);
                    }
                    if (colData[i].type == ColumnType.InputSelect2Ajax) {
                        needNormaliazeSelect2 = true;
                        vals.push(<td data-label={colData[i].caption}>   <DropDownBox includeAll={colData[i].includeAll} defaultValueCellCaption={this.props.Records[j][colData[i].titleColumnName]} entity={colData[i].entity} tableMode={true} width={colData[i].width} rownum={counter} onChange={(e) => { console.log('printer'); this.change(e.target.value, j, colData[i].columnName) }} className='form-control' {...customProp} value={value} onChange={(e) => { console.log('printer'); this.change(e.target.value, j, colData[i].columnName, null, colData[i].rerender) }} /> </td>);

                    }


                    if (colData[i].type == ColumnType.DisplayEnum) {
                        let v2 = value;
                        this.props.Records[j][colData[i].columnName + "_title"] = helpcnt.GetCaptionFromEnum(colData[i].source, v2);
                        vals.push(<td data-label={colData[i].caption}>{helpcnt.GetCaptionFromEnum(colData[i].source,v2 )}</td>);
                    }



                    }
                
            }

            if (this.props.povitColumns != undefined) {
                for (let povitIndexColumn = 0; povitIndexColumn < this.props.povitColumns.length; povitIndexColumn++) {
                    vals.push(<td  >{this.props.Records[j].group[this.props.povitColumns[povitIndexColumn]] }</td>);
                }

            }


            if (hasAction) {
                let actions = [];
                for (let i = 0; i < this.props.children.length; i++) {
                    if (this.props.children[i].type == Action) {
                        if (this.props.children[i].props.showCond != undefined) {
                            let sc = this.props.children[i].props.showCond(this.props.Records[j]);
                            if (sc == false) {
                                continue;
                            }
                        }

                        if (this.props.children[i].props.type == 'Link') {
                            if (this.props.Records[j][this.props.children[i].props.columnName] != undefined) {
                                actions.push(<Link className="dropdown-item" to={'/Admin' + this.props.children[i].props.pageName + '/' + this.props.Records[j][this.props.children[i].props.columnName]}   >  {this.props.children[i].props.caption} {this.props.children[i].props.Icon != undefined && <Icon Icon={this.props.children[i].props.Icon }/> } </Link>);
                            }
                        }
                        if (this.props.children[i].props.type == 'Open') {
                            actions.push(<a className="dropdown-item" target='_blank' href={'/Admin' + this.props.children[i].props.pageName + '/' + this.props.Records[j][this.props.children[i].props.columnName]} > {this.props.children[i].props.caption} {this.props.children[i].props.Icon != undefined && <Icon Icon={this.props.children[i].props.Icon} />} </a >);
                        }

                        if (this.props.children[i].props.type == 'function') {
                            actions.push(<FuncLink key={'x' + Math.random().toString()}  Icon={this.props.children[i].props.Icon} key={'x' + i.toString()} targetFun={this.props.children[i].props.targetFun} DataRow={this.props.Records[j]} showValue={this.props.children[i].props.caption} />)

                        }


                      }

                }
                if (this.Deleteable) {
                    console.log(this.props.Records[j]);
                    actions.push(<FuncLink key={'x' + Math.random().toString()} targetFun={this.DeleteRow} DataRow={this.props.Records[j]} Icon="Delete" showValue={FixedMessage.DeleteRow} />)

                }
                vals.push(<td><ActionButton>{actions}</ActionButton></td>);
            }
            let dat = new Date().getTime();
            let c = {};
            if (this.rowFormating != null) {
                  c = this.rowFormating(this.props.Records[j]);
                
            }

            rows.push(<tr className={c} key={this.props.rekey == true ? 'row' + dat : 'tr' + j}>{vals}</tr>);
        }
        
       
        console.log(this.props.Records.length);
        if (needNormaliazeSelect2) {
            setTimeout(function () { let h = new Helper(); h.NormalaizeSelect2(); }, counter*15);
        }
        let sumEle = [];
        for (let i = 0; i < colData.length; i++) {
            if (colData[i] != undefined) {
                if (colData[i].showSum != undefined) {
                    sumEle.push(<span ><b> مجموع {colData[i].caption} : </b> {window.addCommas(helpcnt.Sum(window[this.DataSourceName], colData[i].columnName))} </span>);
                }
            }
        }
        /*
        <FormDiv style={{}} size='66%'>

            {this.Insertable == true &&

                <SimpleButton Icon="New" onClick={this.Insert} title={FixedMessage.NewRow} ></SimpleButton>
}
 
            <br />
            {this.HideFiltering == undefined && < input type='text' placeholder={FixedMessage.FliterMessage} className='form-control' onChange={this.SetFilter} />}
                
        </FormDiv>
            <FormDiv size='33%'>
                <SimpleButton title='خروجی اکسل' onClick={() => {
                    let h = new Helper();
                    h.fnExcelReport(document.getElementById(this.rndId));
                }}></SimpleButton>
            </FormDiv>
        */
        return <FromBasic>
            <table>
                <tr>
                    {this.Insertable == true &&

                        <td width="180px"><SimpleButton Icon="New" style={{minWidth:'32px'} } onClick={this.Insert} title="ردیف جدید" ></SimpleButton>
                        </td>
                    }
                    {this.HideFiltering == undefined && <td><input type='text' placeholder={FixedMessage.FliterMessage} className='form-control' onChange={this.SetFilter} /></td>}

             

                    <td width="20px"><SimpleButton style={{ minWidth: '32px' }}  Icon="Excel" onClick={() => {
                        let h = new Helper();
                        h.fnExcelReport(document.getElementById(this.rndId));
                    }}  ></SimpleButton>
                        </td>
                    
                </tr>
            </table>
            <table id={this.rndId} key={this.props.rekey == true ? 'tabx' + Math.random().toString() : 'tablex'} className="table table-striped">
                <thead><tr>{cols}</tr></thead><tbody>{rows}</tbody></table>
            {/*<br />*/}
            {/*<center>*/}
            {/*    {sumEle}*/}
            {/*</center>*/}
            {/*<br />*/}
            {/*{this.HideFiltering != true & */}
            
            {/*    <span >تعداد کل رکورد ها:{this.props.Records.length - deteted} تعداد رکورد های نمایش داده شده: {counter} </span>*/}
            {/*}*/}
            
               </FromBasic>
            ;


    }
}

export function ActionButton(porp = { title: 'عملیات' }) {

    return <div className="dropdown">
        <button className="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {porp.title}
        </button>
        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            {porp.children}
        </div>
    </div>;

}

class NewRecordValue extends React.Component {
/**
*
* @param {{columnName:string,newValue:any}} props
*/
    constructor(props) {
        super(props);
        this.props = props;
        this.refs = React.createRef();
    }
    render() {
        return <b>No Render !</b>

    }
}


class Column extends React.Component {
/**
*
* @param {{type:Number,columnName:String,width:String,caption:String,metaForInput:Object,metaForDisplay:Object}} props
*/
    constructor(props) {
        super(props);
        this.props = props;
        this.refs = React.createRef();
    }

    render() {
        return <div />;
    }

    

}

function FromBasic(prop) {

  

    SetWindowTitle(prop);
    return <form className="row g-3 showup"  style={{ margin: '5px' }} >
        {prop.children}
    </form>;


}

function SetWindowTitle(prop) {
    if (prop.staticTitle != undefined) {
        document.title = prop.staticTitle;
    }
}
/*
 @param {{ Records:Array ,datasourcename:String }} props
 */
function FromSubmit(prop) {
/**
*
 * 
 * 
 * 
* @param {{ staticTitle:String ,submitBev:Function,SubmitButtonOnTop:Boolean  ,hideButton:Boolean}} props
    */
    /*
    setTimeout(function(){
        $('#currentForm').hide();
        $('#currentForm').fadeIn(500);
    }, 5);*/
    SetWindowTitle(prop);

    if (prop.SubmitButtonOnTop != true) {
        return <form className="row g-3 showup" onKeyPress={window.checkEnter} id="currentForm" style={{ margin: '5px' }}  >
            {prop.children}
            <div className="col-12">
                <center>
                    {prop.hideButton != true
                        &&
                        <button type="button" className="btn btn-success" onClick={prop.submitBev}><Icon Icon="Yes" />{FixedMessage.Submit}</button>}

                    

                    
                     <BackButton />
                </center>
            </div>

        </form>;
    }
    else {
        return <form className="row g-3 showup" onKeyPress={window.checkEnter} style={{ margin: '5px' }}   >
            
            <div className="col-12">
                <center>
                        <button type="button" className="btn btn-success" onClick={prop.submitBev}><Icon Icon="Yes"/>{FixedMessage.Submit}</button>
                    <BackButton />
                </center>
            </div>
            {prop.children}
        </form>;

    }


}
export function BackButton(props) {
    return <SimpleButton onClick={function () {
        if (window.windowCallBack != undefined) {
            window.close();
            return;
        }


        new Helper().GoBack();
        setTimeout(function () {
             
            if (document.getElementById('root').innerHTML == "") {
                window.reload();
            }
        }, 500);


    }} Icon="Cancel" title={'بازگشت'
} ></SimpleButton>;
}

function FormDiv(prop) {
    let cx = prop.style;
    let colSize = "";
    switch (prop.size) {
        case '100%':
            colSize = 'col-sm-12';
            break;
        case '50%':
            colSize = 'col-sm-6';
            break;
        case '33%':
            colSize = 'col-sm-4';
            break;
        case '25%':
            colSize = 'col-sm-3';
            break;
        case '18%':
            colSize = 'col-sm-2';
            break;
        case '9%':
            colSize = 'col-sm-1';
            break;
        case '75%':
            colSize = 'col-sm-9';
            break;
        case '66%':
            colSize = 'col-sm-8';
            break;
        default:

            break;

    }

    return <div style={cx} className={colSize} mat={prop.mat == undefined?'':'yes'}  >{prop.children}</div>;
    
}
function ReqFilled(prop) {
    return <span style={{ color: 'red' }}>*</span>
}
let CaptiaBase = null;
class Captia extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, url: '' };
        window.CaptiaBase = this;
        this.reload = this.reload.bind(this);
    }
    componentDidMount() {
        console.log('yes');
        if (!this.state.isLoaded) {
            this.reload();
        }
    }
    reload() {
        console.log(this.state.isLoaded);
       
            let help = new Helper();
            let cmd = this;
            help.Ajax('Home', 'GetSecCode', {},
                function (data) {
                    cmd.setState({ isLoaded: true, url: data.url });
                }, function (e) {

                }
            );
        

    }
     
    
    render() {
        if (!this.state.isLoaded) {
            return 'در حال بارگذاری کد امنیتی ';
        }
        else {
            return <FormDiv size="100%" > <div> <img height="80px" src={this.state.url} /> <SimpleButton title='' onClick={this.reload} Icon='Ref' /> </div>
                
            
                <input model="captia" datatype="String" caption="عبارت امنیتی" columnname="captia" mustfill="yes" type="text" class="form-control" id="txtcaptia" />
               
                 
            
            </FormDiv>;
        }
    }
}

function AlertD(props ) {
    return <div className="alert alert-secondary" role="alert" >
        {props.children}
    </div>;

}
window.addCommas = function (nStr) {
    if (nStr == undefined) {
        return "";
    }
      nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
};
window.groupTextbox=function(e)
{
    e.target.value= e.target.value.replace(/,/g, '');
    e.target.value = window.addCommas(e.target.value);

};
window.groupCardMode=function(e)
{
    e.target.value= e.target.value.replace(/-/g, '');
    let s=e.target.value;
    let ex="";
    for(let i=0;i<s.length;i++)
    {
        if(i!=0)
        {
            if(i%4==0)
            {
                ex+="-";
            }
        }
      ex+=s[i];
    }
    e.target.value=ex;

};

window.timeMode = function (e) {
  
        while (e.target.value.length < 4) {
            e.target.value += "0";
        }
    if (e.target.value.length == 4) {
        var x = e.target.value;
        e.target.value = x.substring(0, 2) + ":" + x.substring(2, 4);
    }
    let h = new Helper();
    h.ValidateForItem(e.target.id);
};


class SelectBasic extends React.Component {

    /**
    *
    * @param {{source:Array ,includeAll:Boolean , tableMode:boolean,onChange:Function , caption:string ,columnName:string  ,mustFill:string   ,size:string}} props
    */
    constructor(props) {
        super(props);
        this.props = props;
        this.tableMode = props.tableMode;
        this.onChange = props.onChange;
       

    }
    Change() {
        console.log('parviz');
    }

    componentDidMount() {
        $('#' + 'txt' + this.props.columnName + (this.props.tableMode? this.props.rownum:'')).select2({  });
        $('#' + 'txt' + this.props.columnName + (this.props.tableMode ? this.props.rownum : '')).on('change', this.props.onChange);
    }

    render() {
        let prop = this.props;

        if (DontMustBeRender(prop.ForApp)) {
            return null;
        }

        let customProp = CustomPropForInput(prop);

        let options = [];
    
        for (let i = 0; i < prop.source.length; i++) {
            if ((prop.includeAll) || (prop.source[i].unselectable == false)) {
                options.push(<option value={prop.source[i].value} selected={(prop.source[i].unselectable == true)}  >{prop.source[i].caption}</option>);
            }

        }

        if (this.tableMode != true) {
            return <FormDiv size={prop.size}> <label className="form-label">{prop.caption}: {prop.mustFill == 'Yes' && <ReqFilled />} </label>
                <select type="text" initvalue={prop.columnName} onChange={prop.onChange} model={prop.columnName} datatype="String" {...customProp} className="form-control" id={'txt' + prop.columnName} >
                    {options}

                </select>
            </FormDiv>;
        }
        else {
            return <select type="text"   onchange="console.log('parviz')" className='form-control' datatype="String" {...customProp} /*style={{ width: prop.width }}*/ id={'txt' + prop.columnName + prop.rownum} >
                {options}

            </select>;
        }
    }
}



class InputTextBox extends React.Component {

/**
*
* @param {{ model:string,customHelper:string ,ForApp:String ,caption:string ,columnName:string  ,mustFill:string ,caption:string  ,size:string}} props
*/
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { errors: [] ,words:[] ,rnd:'1' };
        this.customHelper = props.customHelper;
        this.validate = this.validate.bind(this);
        this.openFileMgt = this.openFileMgt.bind(this);
        
    }
    componentDidMount() {
        if (this.customHelper == CustomHelper.isDate) {
            window.kamaDatepicker('txt' + this.props.columnName, { markToday: true });
        }
        if (this.customHelper == CustomHelper.Html) {
        
                window.tinymce.EditorManager.remove();
            window.tinymce.init({ selector: '#' + 'txt' + this.props.columnName, plugins: 'print preview fullpage searchreplace autolink directionality  visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime lists textcolor wordcount imagetools contextmenu colorpicker textpattern help', toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat', height: 300, resize: true });


             
        }
    }
    validate() {
        let h = new Helper();

        if (this.props.customHelper == CustomHelper.isDate) {
            let va = window.$('#' + 'txt' + this.props.columnName).val();
            if (va.length == 8) {
                let val = va.substring(0, 4) + '/' + va.substring(4,6) + '/' + va.substring(6, 8);
                window.$('#' + 'txt' + this.props.columnName).val(val);
            }

        }

        h.ValidateForItem('txt' + this.props.columnName);
        this.setState({ errors: h.errors, words: this.state.words });
    }
    getWord(src, i) {
        let c = '';
        for (let z = i; z >= 0; z--) {
            if (src[z] != ' ') {
                c = src[z] + c;
            }
            else {
                break;
            }
           
        }
        return c;
    }
    openFileMgt() {
        var w = window.open('/Home/FileMgt');
        setTimeout(() => {
            w.fileMgtCallback = (x) => {
                let z = $('#txt' + this.props.columnName).val();
                for (var i = 0; i < x.length; i++) {
                    if ((x[i].exe == '.png') || (x[i].exe == '.jpg')) {
                        z += "<img src='/content/" + x[i].fullName.substring(0, x[i].fullName.length - 1) + "'/>";

                    }
                    else {
                        z += "<a href='/content/" + x[i].fullName.substring(0, x[i].fullName.length - 1) + ">" + x[i].name + '</a>';

                    }
                }
                window.tinymce.editors['txt' + this.props.columnName].setContent(z);
            }
            w.refList();
        }, 3000);
    }
    putObjects(links) {
        let z = $('#txt' + this.props.columnName).val();
        for (var i = 0; i < links.length; i++) {
            if ((links[i].toLowerCase().indexOf('.png') != -1) || (links[i].toLowerCase().indexOf('.jpg') != -1)) {
                z += "<img src='" + links[i] + "'/>";

            }
            else {
                z += "<a href='" + links[i] + ">" + links[i] + '</a>';

            }
        }
        window.tinymce.editors['txt' + this.props.columnName].setContent(z);

    }
    render() {



        let prop = this.props;
        if (DontMustBeRender(this.props.ForApp)) {
            return null;
        }
        let customProp = CustomPropForInput(prop);
        if (this.customHelper == CustomHelper.isDigitngGroupedNumber) {
            customProp.onKeyUp = window.groupTextbox;
        }
        if (this.customHelper == CustomHelper.cardMode) {
            customProp.onKeyUp = window.groupCardMode;
        }
        if (this.customHelper == CustomHelper.timeMode) {
            customProp.onBlur = window.timeMode;
        }
        if (this.customHelper == CustomHelper.LongText) {
            return <FormDiv size={prop.size}> <label className="form-label">{prop.caption}: {prop.mustFill == 'Yes' && <ReqFilled />} </label>
            
                <textarea type="text" onBlur={this.validate}    model={prop.columnName} datatype="String" {...customProp} className="form-control" id={'txt' + prop.columnName} />
                <ErrorList errors={this.state.errors} />
            </FormDiv>;
        }
        if (this.customHelper == CustomHelper.Html) {
            return <FormDiv size={prop.size}> <label className="form-label">{prop.caption}: {prop.mustFill == 'Yes' && <ReqFilled />}
                <SimpleButton title="درج از مدیریت فایل " onClick={this.openFileMgt}  >


                </SimpleButton>
                <QuickUploader mulitFile={true} onUpload={(urls) => { this.putObjects(urls); } }></QuickUploader>
            </label>

                <textarea type="text" onBlur={this.validate} htmlEditor="yes" model={prop.columnName} datatype="String" {...customProp} className="form-control" id={'txt' + prop.columnName} />
                <ErrorList errors={this.state.errors} />
            </FormDiv>;
        }
        if (this.customHelper == CustomHelper.Image) {
            customProp.type = 'text';
            if (prop.justNumber != undefined) {
                customProp.type = 'number';
            }
            return <FormDiv size={prop.size} >
                <label onClick={() => { $('#' + 'txt' + prop.columnName).focus() }} className="form-label">{prop.caption}: {prop.mustFill == 'Yes' && <ReqFilled />} </label>

                <input onChange={() => {
                    
                    let v = $('#txt' + prop.columnName).val();
                    $("img" + prop.columnName).attr('src', v);

                }} onBlur={this.validate}  model={prop.columnName} datatype="String" {...customProp} className="form-control" id={'txt' + prop.columnName} />
                <ErrorList errors={this.state.errors} />
                <br />
                <SimpleButton title="انتخاب از مدیریت فایل" onClick={() => {
                    var w = window.open('/Home/FileMgt');
                    w.onload = () => {

                        setTimeout(() => {
                            w.fileMgtCallback = (x) => {

                                for (var i = 0; i < x.length; i++) {
                                    $('#txt' + prop.columnName).val('/content/' + x[i].fullName.substring(0, x[i].fullName.length - 1));
                                    let v = $('#txt' + prop.columnName).val();
                                    $("#img" + prop.columnName).attr('src', v);
                                }

                            }
                            w.refList();
                        }, 1000);
                    }

                }
                }
                ></SimpleButton>
                <QuickUploader mulitFile={false} onUpload={(urls) => {
                    $('#txt' + prop.columnName).val(urls[0] );
                
                    $("#img" + prop.columnName).attr('src', urls[0]);

                }} ></QuickUploader>
                <img id={"img" + prop.columnName} width="128px" height="128px" />

            </FormDiv>;
        }



        if (this.customHelper == CustomHelper.File) {
            return <FormDiv size={prop.size}> <label className="form-label">{prop.caption}: {prop.mustFill == 'Yes' && <ReqFilled />} </label>
                <input type="file" model={prop.columnName} datatype="file" name={prop.columnName} {...customProp} className="form-control" id={'txt' + prop.columnName} />
            </FormDiv>;

        }
        if (this.customHelper != CustomHelper.File) {
            customProp.type = 'text';
            if (prop.justNumber != undefined) {
                customProp.type = 'number';
            }
            return <FormDiv size={prop.size} > 
                <label onClick={() => { $('#' + 'txt' + prop.columnName).focus() }} className="form-label">{prop.caption}:{prop.mustFill == 'Yes' && <ReqFilled />} </label>

                <input onBlur={this.validate} onChange={this.props.onChange } model={prop.columnName} datatype="String" {...customProp} className="form-control" id={'txt' + prop.columnName} />
                 <ErrorList errors={this.state.errors} />
            </FormDiv>;
        }
    }
}
function ErrorList(props)
{
    return <div>{props.errors.map((x, i) => { return <li>{x}</li> })}</div>;
}
export function ModalCustom(props = { children: [], title: '', id: '' }) {
    return <div class="modal fade" id={props.id} tabindex="-1" role="dialog" data-bs-show="true" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class={"modal-dialog " + (props.dontFull == undefined ? "modal-fullscreen":"")} role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{props.title}</h5>
                    <button type="button" class="close btn" style={{ float: 'left' }} onClick={() => { $("#" + props.id).modal('hide'); }} data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    {props.children}
                </div>

            </div>
        </div>
    </div>;
}


function InputPasswordBox(prop) {
    let customProp = CustomPropForInput(prop);
    return <FormDiv size={prop.size}  > 
        <label onClick={() => { $('#txt' + prop.columnName).focus(); }} htmlFor="inputPassword4" className="form-label" >{prop.caption}{prop.mustFill == 'Yes' && <ReqFilled />}:</label>

        <input type="password" onBlur={function () { let h = new Helper(); h.ValidateForItem('txt' + prop.columnName); }} model={prop.columnName}  {...customProp} datatype="String" className="form-control" id={'txt' + prop.columnName} />
           </FormDiv>

}


function CustomPropForInput(prop) {
    const Customprop = [];
    
    let keys = Object.keys(prop);
    for (let i = 0; i < keys.length; i++) {
        if (keys[i] != 'type') {
            Customprop[keys[i]] = prop[keys[i]];
        }
    }
    return Customprop;
}


function Model(prop) {
    return <div> <div className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="modal_title">Modal title</h5>
                    
                </div>
                <div className="modal-body" id="modal_body">
                    ...
      </div>
                <div className="modal-footer">

                    <button type="button" className="btn btn-primary" onClick={function () { $('#myModal').modal('hide') }} ><Icon Icon='Yes'></Icon>تایید</button>
                </div>
            </div>
        </div>
    </div>
        <div class="alert alert-primary messageBox" role="alert">
            <span id="messageText">This is a primary alert—check it out!</span> 
            <br />
            <center>
            <SimpleButton title="متوجه شدم" Icon="Yes" onClick={() => {$('.messageBox').fadeOut('0.5s') } } ></SimpleButton>
            </center>
        </div>
    </div>


}
function Confirm(prop) {
    return <div className="modal fade" id="conmyModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="conmodal_title">Modal title</h5>

                </div>
                <div className="modal-body" id="conmodal_body">
                    ...
      </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-light" onClick={function () { $('#conmyModal').modal('hide'); window.noFun(); }} ><Icon Icon="No" />خیر </button>
                    
                    <button type="button" className="btn btn-primary" onClick={function () { $('#conmyModal').modal('hide'); window.confimFun(); }} ><Icon Icon="Yes" />بله</button>
                </div>
            </div>
        </div>
    </div>;


}
function YesNo(props) {
    return <center >  <button type="button" className="btn btn-light" onClick={props.noFun  } ><Icon Icon="No" />خیر </button>
        <button type="button" className="btn btn-primary" onClick={props.yesFun } ><Icon Icon="Yes" />بله</button>

     
 </center >;
}

function InputBox(props) {
    let hlp = new Helper();
    let meta = props.meta;
    let rprop = {};
    rprop.size = props.size;
    hlp.PutDataInObjet(meta, 'DisplayName', rprop, 'caption', meta['DisplayName']);
    let targetKey = ['mustFill', 'isemail', 'mobile','natCode','justNumber','Html'];
    for (let i = 0; i < targetKey.length; i++) {
        hlp.PutDataInObjet(meta, targetKey[i], rprop, targetKey[i], 'Yes');
    }
    hlp.PutDataInObjetCopy(props, 'minlength', rprop);
    
    hlp.PutDataInObjetCopy(props, 'maxlength', rprop);
    hlp.PutDataInObjetCopy(props, 'disabled', rprop);
    hlp.PutDataInObjetCopy(props, 'change', rprop);
    hlp.PutDataInObjetCopy(props, 'unselectable', rprop);
    if (meta.type.indexOf('System.DateTime')!=-1) {
        rprop.customHelper = CustomHelper.isDate;
    }
    if (meta.LongText != undefined) {
        rprop.customHelper = CustomHelper.LongText;
    }
    hlp.PutDataInObjet(meta, 'MoneyDigited', rprop, 'customHelper', CustomHelper.isDigitngGroupedNumber);
 
    if (props.customHelper == CustomHelper.cardMode)
    {
        rprop.customHelper=props.customHelper;
    }
    if (props.customHelper == CustomHelper.timeMode) {
        rprop.customHelper = props.customHelper;
    }
    if (props.customHelper == CustomHelper.Html) {
        rprop.customHelper = props.customHelper;
    }
    if (props.customHelper == CustomHelper.Image) {
        rprop.customHelper = props.customHelper;
    }
    rprop.columnName = meta.name;
    rprop.initValue = hlp.jsonNameFix(meta.name);
    if (props.ForApp != undefined) {
        rprop.ForApp = props.ForApp;
    }
    if (meta.ForeignKey == undefined) {
        if (meta.type.indexOf('System.') == -1) {
            rprop.source = enums[meta.type.replace('Reach.', '')];
            rprop.includeAll = props.includeAll;
            return <SelectBasic {...rprop} />

        }
        else {
            return <InputTextBox {...rprop} ></InputTextBox>
        }
        
    }
    else {
        rprop.entity = meta.ForeignKey;
        rprop.includeAll = props.includeAll;
        return <DropDownBox {...rprop} />
    }

    
}
function SideView(props) {

    return <div class="accordion" id="accordionExample">{props.children} </div>
}
function SideItem(props) {
   
    return  <div class="accordion-item"> <h2 class="accordion-header">
        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={'#' + props.id} aria-expanded="false" aria-controls="collapseOne">
            {props.title}
        </button>
    </h2>
        <div id={props.id} class="accordion-collapse collapse hide" >
            <div class="accordion-body">
                {props.children}
            </div>
        </div></div> ;

}
export function ShowFixedPage(props = { id: '' }) {
    const [pageState, loadState] = useState ({ value: '', isLoaded: false });

    const load = () => {
        let h = new Helper();
        h.Ajax('FixedPage', 'Get', { id: props.id }, (data) => {
            loadState({ value: data.value, isLoaded: true });
        }            
        );


    };


    if (pageState.isLoaded == false) {
        load();
        return <LoadingBar />;
    }


    return <span dangerouslySetInnerHTML={{ __html: pageState.value }} ></span >

}
export function Paging(props = { targetFun:null, totalPage:null, currentPage:null }) {
    let pages = [];
    for (let i = 1; i <= props.totalPage; i++) {
        pages.push(<li onClick={() => { props.targetFun(i) }} class={"page-item" + (i == props.currentPage ? " active" : "")}>
            <span class="page-link"><a >{i}</a></span>
        </li>);
    }



    return <nav class="mt-4">
        <ul class="pagination justify-content-center">

            {
                props.currentPage != 1 && <li class="page-item">
                    <span class="page-link"><a onClick={() => { props.targetFun(props.currentPage - 1) }}>قبلی</a></span>
                </li>
            }

            {pages}


            {
                props.currentPage != props.totalPage && <li class="page-item">
                    <span class="page-link"><a onClick={() => { props.targetFun(props.currentPage + 1) }}>بعدی</a></span>
                </li>
            }

        </ul>
    </nav>



}
export function QuickUploader(props = { onUpload: (urls) => { }, justImage: false, mulitFile: false }) {
    let id = 'txtUpload' + Math.random() * 10000;
    let attr = [];
    const upload = () => {
        let formData = new FormData();
        let h = new Helper();
        let ele = document.getElementById(id);
        if (ele.files.length == 0) {
            h.Alert('فایلی انتخاب نشده');
            $('#' + id).click();
            return;
        }
        for (let i = 0; i < ele.files.length; i++) {
            formData.append('files', ele.files[i], ele.files[i].value);
        }

        h.AjaxForUpload('FileMgt', 'QuickUpload', formData, (data) => {
            if (data.status == '500') {
                h.Error(data.message);
            }
            else {
                props.onUpload(data);
            }
        });


    }

    return <span>
        {(props.mulitFile == false || (props.mulitFile == undefined)) && <input onChange={upload} id={id} style={{ display: 'none' }} type="file"  ></input>}
        {props.mulitFile == true && <input id={id} style={{ display: 'none' }} onChange={upload} type="file" multiple ></input>}
        <label for={id} className="btn btn-light">ارسال سریع</label>
    </span>
}

export {
    Menu, ProTable, Column, AddButton, FromBasic, FixedMessage
    , Confirm, ColumnType, LoadingBar, FileProgess, SelectBasic, Action, DayTimeSelector, FromSubmit, InputTextBox, InputBox, InputPasswordBox, Model, Captia, SideView, SideItem
    , AlertD, SimpleButton, RowState, Icon, NewRecordValue, DropDownBox, CustomHelper, SpecValues, FormDiv
    , YesNo
}


